import React from 'react';
import Bg from '../../images/shapes/shape_title_under_line.svg'
import circle1 from '../../images/hero/circle_engine_1.svg'
import circle2 from '../../images/hero/circle_engine_2.webp'
import circle3 from '../../images/hero/circle_engine_3.webp'
import circle4 from '../../images/hero/circle_engine_4.webp'
import shape1 from '../../images/hero/shape_image_1.webp'
import shape2 from '../../images/hero/shape_image_2.webp'
import shape3 from '../../images/hero/shape_image_3.webp'
import shape4 from '../../images/hero/shape_image_4.webp'
import {Link} from "react-router-dom";

const Hero = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (

        <section className="software_company_hero_section xb-hidden">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="content_wrap">
                            <div className="heading_focus_text has_underline text-white d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Your Partner in cyber
                            </div>
                            <h1 className="text-white">
                                Jouw partner in <mark>Cybersecurity</mark>
                            </h1>
                            <p>
                                In een wereld waar cyberdreigingen continu toenemen, verdienen bedrijven van elke omvang robuuste en toegankelijke beveiligingsoplossingen. Praeventor biedt op maat gemaakte beveiligingsdiensten voor groeiende bedrijven die vooruit willen zonder zorgen over hun digitale veiligheid.
                            </p>
                            <ul className="step_list text-white unordered_list_block">
                                <li>Wij zorgen voor de bescherming, zodat jij kunt focussen op jouw expertise.</li>
                                <li>Ontwikkel met vertrouwen</li>
                            </ul>
                            <ul className="btns_group unordered_list p-0 justify-content-start">
                                <li>
                                    <Link onClick={ClickHandler} className="btn btn-primary" to="/contact">
                                        <span className="btn_label" data-text="NEEM CONTACT OP">NEEM CONTACT OP</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="engine_image">
                            <div className="image_wrap_1">
                                <img src={circle1} alt="Engine" width="100px" />
                            </div>
                            <div className="image_wrap_2">
                                <img src={circle2} alt="Engine" />
                            </div>
                            <div className="image_wrap_3">
                                <img src={circle3} alt="Engine" />
                            </div>
                            <div className="image_wrap_4">
                                <img src={circle4} alt="Engine" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="shape_image_1">
                <img src={shape1} alt="Engine" />
            </div>
            <div className="shape_image_2">
                <img src={shape2} alt="Engine" />
            </div>
            <div className="shape_image_3">
                <img src={shape3} alt="Engine" />
            </div>
            <div className="shape_image_4">
                <img src={shape4} alt="Engine" />
            </div>
        </section>
    )
}

export default Hero;